import { compose, when } from 'ramda'

const datetimeStringToTimestampConverter = compose(
  when(Number.isNaN, () => null),
  (value) => new Date(value).getTime() / 1000,
)

export default datetimeStringToTimestampConverter
